import AppError from './errors/app-errors'
import http from './webhook/httpconfig'
import { cancelHTTPRequests } from '@/services/utils'
import { generateHeaders } from './webhook/webhook'
import { getElevenLabsConnectionConfigs } from './utils'
import store from '@/store'
export async function getTextToSpeech(data) {
  try {
    const provider = store?.getters?.voiceTTSProvider
    const isElevenLabs = provider === '11labs'
    const url = isElevenLabs
      ? '/api/speech/get-streaming-speech'
      : '/api/speech/text-to-speech'
    const requestData = isElevenLabs
      ? { ...data, ...getElevenLabsConnectionConfigs() }
      : data
    const response = await http.request({
      method: 'post',
      url,
      headers: {
        'Cache-Control': 'no-cache',
        ...generateHeaders()
      },
      data: requestData,
      cancelToken: cancelHTTPRequests()
    })
    return response.data?.payload || ''
  } catch (err) {
    throw new AppError({
      name: 'Get text to speech',
      message: `Error while getting response audio. ${err.message}`
    })
  }
}
